import { render, staticRenderFns } from "./user.vue?vue&type=template&id=38912a15&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./user.vue?vue&type=style&index=1&id=38912a15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38912a15",
  null
  
)

export default component.exports